export const useCurrentPage = () => {
    const route = useRoute();

    return useState(
        '@dn/currentPage',
        () => {
            return parseInt((route?.query?.page ?? route?.query?.p) ?? 1, 10);
        }
    );
};
